module.exports = __webpack_public_path__ + "img/auto-sliding-carousel-stories.ec1aeeb8.png";